import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical, Loader2 } from "lucide-react";
import { api, apiErrorMessage } from "../../lib/api";
import { experimentAnswers, experimentStepLabel } from "../../lib/limoGroup";

/**
 * The sandbox licence experiment (22.09.2026): does removing a student free
 * their licence, does a move spend a new one. Test pools only, owner only.
 */
export default function LimoLicenceExperiment() {
  const [run, setRun] = useState(null);
  const [allowed, setAllowed] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/limo/licence-experiment/last")
      .then((r) => setRun(r.data.run))
      .catch(() => setAllowed(false));
  }, []);

  if (!allowed) return null;

  const start = async () => {
    if (!window.confirm("Rulez verificarea pe pool-urile de PROBĂ? Un cursant fictiv e înscris într-o grupă de probă, "
      + "scos, mutat în altă grupă de probă, apoi scos și dezactivat. Nicio licență reală. Durează cam 30 de secunde.")) return;
    setBusy(true);
    try {
      const r = await api.post("/admin/limo/licence-experiment");
      setRun({ ...r.data, status: "done" });
      toast.success("Verificarea s-a terminat.");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Verificarea nu a rulat."));
    } finally {
      setBusy(false);
    }
  };

  const steps = run?.steps || [];
  const poolNames = [...new Set(steps.flatMap((s) => s.pools.map((p) => p.name)))];

  return (
    <div className="mt-4 rounded-xl border border-[#E5E7EB] p-3" data-testid="limo-licence-experiment">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-sm font-semibold text-[#373A45]">Verificare licențe (probă)</div>
        <button type="button" onClick={start} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-full bg-[#519872] hover:bg-[#3f7a5c] px-3 py-1 text-xs font-semibold text-white disabled:opacity-50"
          data-testid="limo-experiment-run">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <FlaskConical size={12} />}
          {busy ? "Rulează…" : run ? "Rulează din nou" : "Rulează verificarea"}
        </button>
      </div>
      <p className="mt-1 text-[11px] text-[#6B7280]">
        Răspunde ce se întâmplă cu licența la scoaterea din grupă și la mutare. Doar pe pool-urile de probă.
      </p>
      {run && run.answers && (
        <>
          <ul className="mt-2 space-y-0.5 text-xs" data-testid="limo-experiment-answers">
            {experimentAnswers(run.answers).map(([q, a]) => (
              <li key={q}><span className="text-[#6B7280]">{q}:</span> <strong className="text-[#373A45]">{a}</strong></li>
            ))}
          </ul>
          <div className="mt-2 overflow-x-auto">
            <table className="min-w-full text-[11px] tabular-nums">
              <thead>
                <tr className="text-left text-[#6B7280]">
                  <th className="pr-3 py-1">Pas</th>
                  {poolNames.map((n) => <th key={n} className="pr-3 py-1">{n}: ocupate / active / suspendate</th>)}
                  <th className="pr-3 py-1">Membri A / B</th>
                  <th className="py-1">Eroare</th>
                </tr>
              </thead>
              <tbody>
                {steps.map((s) => (
                  <tr key={s.step} className="border-t border-[#E5E7EB]">
                    <td className="pr-3 py-1">{experimentStepLabel(s.step)}</td>
                    {poolNames.map((n) => {
                      const p = s.pools.find((x) => x.name === n) || {};
                      return <td key={n} className="pr-3 py-1">{p.assignedCount ?? "—"} / {p.activeCount ?? "—"} / {p.suspendedCount ?? "—"}</td>;
                    })}
                    <td className="pr-3 py-1">{s.members?.a ?? "—"} / {s.members?.b ?? "—"}</td>
                    <td className="py-1 text-[#9b1f2c]">{s.ok === false ? (s.error || "eșuat") : ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
